export default __webpack_public_path__ + "static/media/resale.c8da912d.png";